import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: modules
});
window.$store = store;
export default store;